// extracted by mini-css-extract-plugin
module.exports = {"radioButtonContainer":"SN","address":"TN","showOnlySmallScreen":"UN"};